var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

// src/components/activity-faqs/activity-faqs.tsx
import React20 from "react";
import { EGDSCard, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";

// ../internal/src/components/activity-clickstream-analytics/activity-clickstream-analytics.tsx
import { gql } from "@shared-ui/apollo-client-wrapper";
var EGClickstreamActivityAnalyticsFragment = gql`
  fragment ActivityClickstreamAnalyticsFragment on ActivityClickstreamAnalytics {
    clickstreamEvent {
      ...ActivityClickstreamEventAnalyticsFragment
    }
    payload
  }
  fragment ActivityClickstreamEventAnalyticsFragment on ActivityClickstreamEventAnalytics {
    eventName
    eventType
    eventVersion
    eventCategory
    actionLocation
    pageName
    pageNameDetailed
    pageProductLine
  }
`;

// ../internal/src/components/egds-text/egds-heading.tsx
import React from "react";
import { EGDSHeading } from "@egds/react-core/text";
import { gql as gql2 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/__private/heading-map.ts
var headingTagMapper = {
  ["H1" /* H1 */]: "h1",
  ["H2" /* H2 */]: "h2",
  ["H3" /* H3 */]: "h3",
  ["H4" /* H4 */]: "h4",
  ["H5" /* H5 */]: "h5",
  ["H6" /* H6 */]: "h6",
  ["H7" /* H7 */]: "h6",
  ["H8" /* H8 */]: "h6"
};

// ../internal/src/components/egds-text/egds-heading.tsx
var fragment = gql2`
  fragment EGDSHeadingFragment on EGDSHeading {
    text
    headingType
    accessibility
  }
`;
var ActivitiesEGDSHeading = ({
  className,
  align,
  size,
  tag,
  data,
  tabIndex
}) => {
  const {
    headingType,
    text,
    accessibility
  } = data;
  const headingTag = tag != null ? tag : headingType ? headingTagMapper[headingType] : void 0;
  return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(EGDSHeading, {
    className,
    align,
    tag: tag != null ? tag : headingTag,
    size,
    tabIndex,
    "aria-hidden": accessibility !== null
  }, text), accessibility && /* @__PURE__ */React.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
ActivitiesEGDSHeading.fragment = fragment;
ActivitiesEGDSHeading.displayName = "ActivitiesEGDSHeading";

// ../internal/src/components/egds-text/egds-paragraph.tsx
import React2 from "react";
import { EGDSParagraph } from "@egds/react-core/text";
import { gql as gql3 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/__private/paragraph-style-size-map.ts
var paragraphStyleSizeMap = {
  ["P1" /* P1 */]: 1,
  ["P2" /* P2 */]: 2,
  ["P3" /* P3 */]: 3
};

// ../internal/src/components/egds-text/egds-paragraph.tsx
var fragment2 = gql3`
  fragment EGDSParagraphFragment on EGDSParagraph {
    text
    style
  }
`;
var ActivitiesEGDSParagraph = ({
  className,
  data
}) => {
  const {
    text,
    style
  } = data;
  return /* @__PURE__ */React2.createElement(EGDSParagraph, {
    className,
    size: paragraphStyleSizeMap[style]
  }, text);
};
ActivitiesEGDSParagraph.fragment = fragment2;
ActivitiesEGDSParagraph.displayName = "ActivitiesEGDSParagraph";

// ../internal/src/components/egds-text/egds-standard-link.tsx
import React9 from "react";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSText } from "@egds/react-core/text";
import { gql as gql7 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/components/egds-graphic/egds-icon.tsx
import React6 from "react";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { gql as gql4 } from "@shared-ui/apollo-client-wrapper";

// ../../../core/utilities/react-compatibility/src/use-id-compatibility.ts
import React3 from "react";
var useLegacyCustomId = () => React3.useMemo(() => Math.random().toString(36).substring(7), []);
var _a;
var useIdCompatibility = (_a = React3.useId) != null ? _a : useLegacyCustomId;

// ../../../core/utilities/react-compatibility/src/use-start-transition-compatibility.ts
import React5 from "react";

// ../../../core/utilities/react-compatibility/src/use-transition-compatibility.ts
import React4 from "react";

// ../internal/src/components/egds-graphic/egds-icon.tsx
var __EGDSIconFragment = gql4`
  fragment EGDSIconFragment on Icon {
    description
    id
    size
    theme
    title
    withBackground
  }
`;
var ActivitiesEGDSIcon = ({
  className,
  data
}) => {
  var _a2, _b;
  const iconId = useIdCompatibility();
  return /* @__PURE__ */React6.createElement(EGDSIcon, {
    className,
    description: data.description,
    id: iconId,
    name: data.id,
    size: data.size ? EGDSIconSize[data.size] : void 0,
    title: (_a2 = data.title) != null ? _a2 : void 0,
    theme: (_b = data == null ? void 0 : data.theme) != null ? _b : void 0,
    shadow: Boolean(data.withBackground)
  });
};
ActivitiesEGDSIcon.displayName = "ActivitiesEGDSIcon";
ActivitiesEGDSIcon.fragment = __EGDSIconFragment;

// ../internal/src/components/egds-graphic/egds-mark.tsx
import React7 from "react";
import { EGDSMark, EGDSMarkSize } from "@egds/react-core/mark";
import { gql as gql5 } from "@shared-ui/apollo-client-wrapper";
var __EGDSMarkFragment = gql5`
  fragment EGDSMarkFragment on Mark {
    description
    id
    markSize: size
    url {
      ... on HttpURI {
        __typename
        relativePath
        value
      }
    }
  }
`;
var ActivitiesEGDSMark = ({
  className,
  data
}) => {
  var _a2;
  return /* @__PURE__ */React7.createElement(EGDSMark, {
    className,
    description: data.description,
    id: data.id,
    name: data.id,
    size: data.markSize ? EGDSMarkSize[data.markSize] : void 0,
    url: (_a2 = data.url) == null ? void 0 : _a2.value
  });
};
ActivitiesEGDSMark.displayName = "ActivitiesEGDSMark";
ActivitiesEGDSMark.fragment = __EGDSMarkFragment;

// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React8 from "react";
import { gql as gql6 } from "@shared-ui/apollo-client-wrapper";
var __EGDSGraphicFragment = gql6`
  fragment EGDSGraphicFragment on UIGraphic {
    ... on Icon {
      ...EGDSIconFragment
    }

    ... on Mark {
      ...EGDSMarkFragment
    }
  }

  ${ActivitiesEGDSIcon.fragment}
  ${ActivitiesEGDSMark.fragment}
`;
var EGDSGraphic = ({
  className,
  data
}) => {
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React8.createElement(ActivitiesEGDSIcon, {
        className,
        data
      });
    case "Mark":
      return /* @__PURE__ */React8.createElement(ActivitiesEGDSMark, {
        className,
        data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;

// ../internal/src/components/egds-text/__private/link-map.ts
var linkSizeMapper = {
  ["SMALL" /* SMALL */]: "small",
  ["MEDIUM" /* MEDIUM */]: "medium",
  ["LARGE" /* LARGE */]: "large"
};
var UILinkTargetMap = {
  ["EXTERNAL" /* EXTERNAL */]: "_blank",
  ["INTERNAL" /* INTERNAL */]: "_self"
};

// ../internal/src/components/egds-text/egds-standard-link.tsx
var fragment3 = gql7`
  fragment EGDSStandardLinkFragment on EGDSStandardLink {
    action {
      accessibility
      analytics {
        linkName
        referrerId
      }
      resource {
        value
        ... on HttpURI {
          relativePath
        }
      }
      target
      useRelativePath
    }
    disabled
    standardLinkIcon: icon {
      ...EGDSIconFragment
    }
    iconPosition
    size
    text
  }

  ${ActivitiesEGDSIcon.fragment}
`;
var IconPlacement = ({
  icon,
  iconPosition,
  iconPositionToMatch
}) => {
  if (icon && iconPosition === iconPositionToMatch) {
    return /* @__PURE__ */React9.createElement(ActivitiesEGDSIcon, {
      data: icon
    });
  }
  return null;
};
var EGDSStandardLink = ({
  className,
  inline,
  align,
  data: {
    action: {
      analytics,
      resource,
      target,
      accessibility,
      useRelativePath
    },
    disabled,
    iconPosition,
    standardLinkIcon,
    size,
    text
  }
}) => {
  const clickTracker = useClickTracker();
  const onClick = React9.useCallback(() => {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  const getPath = React9.useCallback(() => {
    switch (resource.__typename) {
      case "HttpURI":
        return useRelativePath ? resource.relativePath : resource.value;
      default:
        return resource.value;
    }
  }, [resource, useRelativePath]);
  return /* @__PURE__ */React9.createElement(EGDSLink, {
    className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    inline,
    disabled,
    align
  }, /* @__PURE__ */React9.createElement("a", {
    target: UILinkTargetMap[target],
    href: getPath()
  }, /* @__PURE__ */React9.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition,
    iconPositionToMatch: "LEADING" /* LEADING */
  }), text, /* @__PURE__ */React9.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition,
    iconPositionToMatch: "TRAILING" /* TRAILING */
  }), accessibility && /* @__PURE__ */React9.createElement(EGDSText, {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.fragment = fragment3;
EGDSStandardLink.displayName = "EGDSStandardLink";

// ../internal/src/components/egds-text/egds-text.tsx
import React17 from "react";
import { gql as gql15 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React10 from "react";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
import { gql as gql8 } from "@shared-ui/apollo-client-wrapper";
var fragment4 = gql8`
  fragment EGDSGraphicTextFragment on EGDSGraphicText {
    graphic {
      ...EGDSGraphicFragment
    }
    text
  }

  ${EGDSGraphic.fragment}
`;
var graphicMargin = {
  inlineend: "one"
};
var textMargin = {
  inlineend: "one"
};
var EGDSGraphicText = ({
  className,
  size,
  data
}) => {
  const {
    graphic,
    text
  } = data;
  return /* @__PURE__ */React10.createElement(EGDSLayoutFlex, {
    className
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React10.createElement(EGDSSpacing, {
    margin: graphicMargin
  }, /* @__PURE__ */React10.createElement(EGDSGraphic, {
    data: graphic
  }))), /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem, {
    alignSelf: "center"
  }, /* @__PURE__ */React10.createElement(EGDSSpacing, {
    margin: textMargin
  }, /* @__PURE__ */React10.createElement(EGDSText2, {
    size
  }, text))));
};
EGDSGraphicText.fragment = fragment4;
EGDSGraphicText.displayName = "EGDSGraphicText";

// ../internal/src/components/egds-text/egds-icon-text.tsx
import React11 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { gql as gql9 } from "@shared-ui/apollo-client-wrapper";
var fragment5 = gql9`
  fragment EGDSIconTextFragment on EGDSIconText {
    icon {
      ...EGDSIconFragment
    }
    text
  }

  ${ActivitiesEGDSIcon.fragment}
`;
var iconMargin = {
  inlineend: "one"
};
var textMargin2 = {
  inlineend: "one"
};
var EGDSIconText = ({
  className,
  size,
  data
}) => {
  const {
    icon,
    text
  } = data;
  return /* @__PURE__ */React11.createElement(EGDSLayoutFlex2, {
    className
  }, /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React11.createElement(EGDSSpacing2, {
    margin: iconMargin
  }, /* @__PURE__ */React11.createElement(ActivitiesEGDSIcon, {
    data: icon
  }))), /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem2, {
    alignSelf: "center"
  }, /* @__PURE__ */React11.createElement(EGDSSpacing2, {
    margin: textMargin2
  }, /* @__PURE__ */React11.createElement(EGDSText3, {
    size
  }, text))));
};
EGDSIconText.fragment = fragment5;
EGDSIconText.displayName = "EGDSIconText";

// ../internal/src/components/egds-text/egds-inline-link.tsx
import React12 from "react";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { gql as gql10 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var fragment6 = gql10`
  fragment EGDSInlineLinkFragment on EGDSInlineLink {
    action {
      accessibility
      analytics {
        linkName
        referrerId
      }
      resource {
        value
      }
      target
    }
    disabled
    size
    text
  }
`;
var EGDSInlineLink = ({
  className,
  data: {
    action: {
      analytics,
      resource,
      target,
      accessibility
    },
    disabled,
    size,
    text
  }
}) => {
  const clickTracker = useClickTracker2();
  const onClick = React12.useCallback(() => {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  return /* @__PURE__ */React12.createElement(EGDSLink2, {
    className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    disabled,
    inline: true
  }, /* @__PURE__ */React12.createElement("a", {
    href: resource.value,
    target: UILinkTargetMap[target]
  }, text, accessibility && /* @__PURE__ */React12.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSInlineLink.fragment = fragment6;
EGDSInlineLink.displayName = "EGDSInlineLink";

// ../internal/src/components/egds-text/egds-plain-text.tsx
import React13 from "react";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
import { gql as gql11 } from "@shared-ui/apollo-client-wrapper";
var fragment7 = gql11`
  fragment EGDSPlainTextFragment on EGDSPlainText {
    text
  }
`;
var EGDSPlainText = ({
  className,
  inline,
  align,
  size,
  theme,
  data
}) => {
  const {
    text
  } = data;
  return /* @__PURE__ */React13.createElement(EGDSText4, {
    whiteSpace: "pre-line",
    className,
    align,
    size,
    inline,
    theme
  }, text);
};
EGDSPlainText.fragment = fragment7;
EGDSPlainText.displayName = "EGDSPlainText";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React16 from "react";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";
import { gql as gql14 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
import React15 from "react";
import { gql as gql13 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React14 from "react";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
import { gql as gql12 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/__private/text-theme.ts
var textThemeMapper = {
  ["EMPHASIS" /* EMPHASIS */]: "emphasis",
  ["NEGATIVE" /* NEGATIVE */]: "negative",
  ["POSITIVE" /* POSITIVE */]: "positive",
  ["PRIMARY" /* PRIMARY */]: "emphasis",
  ["SECONDARY" /* SECONDARY */]: "default",
  ["LOYALTY" /* LOYALTY */]: "loyalty",
  ["INVERSE" /* INVERSE */]: "inverse"
};
var EGDSTextThemeMapper = {
  ["NEGATIVE" /* NEGATIVE */]: "negative",
  ["POSITIVE" /* POSITIVE */]: "positive",
  ["EMPHASIS" /* EMPHASIS */]: "emphasis",
  ["LOYALTY" /* LOYALTY */]: "loyalty",
  ["DEFAULT" /* DEFAULT */]: "default"
};

// ../internal/src/components/egds-text/__private/text-weight.ts
var textWeightMapper = {
  ["BOLD" /* BOLD */]: "bold",
  ["MEDIUM" /* MEDIUM */]: "medium",
  ["REGULAR" /* REGULAR */]: "regular"
};

// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment8 = gql12`
  fragment EGDSStylizedTextFragment on EGDSStylizedText {
    text
    theme
    weight
    accessibility
    decorative
    textSize: size
  }
`;
var EGDSStylizedText = ({
  className,
  inline,
  align,
  size,
  data
}) => {
  const {
    text,
    theme,
    weight,
    accessibility,
    decorative
  } = data;
  const themeProps = theme ? textThemeMapper[theme] : void 0;
  const weightProps = weight ? textWeightMapper[weight] : void 0;
  const RenderText = () => /* @__PURE__ */React14.createElement(React14.Fragment, null, /* @__PURE__ */React14.createElement(EGDSText5, {
    className,
    align,
    inline,
    size,
    theme: themeProps,
    weight: weightProps,
    "aria-hidden": accessibility !== null
  }, text), accessibility && /* @__PURE__ */React14.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
  switch (decorative) {
    case "LINE_THROUGH" /* LINE_THROUGH */:
      return /* @__PURE__ */React14.createElement("s", null, /* @__PURE__ */React14.createElement(RenderText, null));
    default:
      return /* @__PURE__ */React14.createElement(RenderText, null);
  }
};
EGDSStylizedText.fragment = fragment8;
EGDSStylizedText.displayName = "EGDSStylizedText";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
var fragment9 = gql13`
  fragment EGDSSpannableTextContentFragment on EGDSText {
    ...EGDSStylizedTextFragment
    ...EGDSGraphicTextFragment
    ...EGDSPlainTextFragment
  }

  ${EGDSStylizedText.fragment}
  ${EGDSGraphicText.fragment}
  ${EGDSPlainText.fragment}
`;
var EGDSSpannableTextContent = ({
  className,
  size,
  align,
  theme,
  data
}) => {
  switch (data.__typename) {
    case "EGDSStylizedText":
      return /* @__PURE__ */React15.createElement(EGDSStylizedText, {
        className,
        data,
        size,
        inline: true
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React15.createElement(EGDSGraphicText, {
        className,
        data,
        size
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React15.createElement(EGDSPlainText, {
        className,
        data,
        size,
        align,
        inline: true,
        theme
      });
    default:
      return null;
  }
};
EGDSSpannableTextContent.fragment = fragment9;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment10 = gql14`
  fragment EGDSSpannableTextFragment on EGDSSpannableText {
    text
    contents {
      ...EGDSSpannableTextContentFragment
    }
    inlineContent {
      ...EGDSSpannableTextContentFragment
    }
  }

  ${EGDSSpannableTextContent.fragment}
`;
var EGDSSpannableText = props => {
  var _b, _c, _d;
  const _a2 = props,
    {
      align,
      headingSize,
      data,
      theme
    } = _a2,
    styleProps = __objRest(_a2, ["align", "headingSize", "data", "theme"]);
  if (((_b = data == null ? void 0 : data.contents) == null ? void 0 : _b.length) === 0 && !((_c = data == null ? void 0 : data.inlineContent) == null ? void 0 : _c.length)) {
    return /* @__PURE__ */React16.createElement(EGDSText6, __spreadProps(__spreadValues({}, styleProps), {
      inline: true,
      align,
      theme
    }), data.text);
  }
  if ((_d = data == null ? void 0 : data.inlineContent) == null ? void 0 : _d.length) {
    return /* @__PURE__ */React16.createElement(React16.Fragment, null, data.inlineContent.map((item, index) => /* @__PURE__ */React16.createElement(React16.Fragment, null, /* @__PURE__ */React16.createElement(EGDSSpannableTextContent, __spreadProps(__spreadValues({
      align,
      data: item
    }, styleProps), {
      key: `spannable-item-${index}`,
      theme
    })), " ")));
  }
  return /* @__PURE__ */React16.createElement(React16.Fragment, null, data.contents.map((item, index) => /* @__PURE__ */React16.createElement(React16.Fragment, {
    key: `spannable-item-${index}`
  }, /* @__PURE__ */React16.createElement(EGDSSpannableTextContent, __spreadProps(__spreadValues({
    data: item
  }, styleProps), {
    headingSize,
    theme
  })), " ")));
};
EGDSSpannableText.fragment = fragment10;
EGDSSpannableText.displayName = "EGDSSpannableText";

// ../internal/src/components/egds-text/egds-text.tsx
var fragment11 = gql15`
  fragment EGDSTextFragment on EGDSText {
    ...EGDSHeadingFragment
    ...EGDSPlainTextFragment
    ...EGDSStylizedTextFragment
    ...EGDSIconTextFragment
    ...EGDSGraphicTextFragment
    ...EGDSParagraphFragment
    ...EGDSStandardLinkFragment
    ...EGDSInlineLinkFragment
    ...EGDSSpannableTextFragment
  }

  ${ActivitiesEGDSHeading.fragment}
  ${EGDSPlainText.fragment}
  ${EGDSStylizedText.fragment}
  ${EGDSIconText.fragment}
  ${EGDSGraphicText.fragment}
  ${ActivitiesEGDSParagraph.fragment}
  ${EGDSStandardLink.fragment}
  ${EGDSInlineLink.fragment}
  ${EGDSSpannableText.fragment}
`;
var ActivitiesEGDSText = ({
  className,
  headingAlign,
  headingSize,
  headingTag,
  textAlign,
  textSize,
  align,
  inline,
  tabIndex,
  theme,
  data
}) => {
  switch (data == null ? void 0 : data.__typename) {
    case "EGDSHeading":
      return /* @__PURE__ */React17.createElement(ActivitiesEGDSHeading, {
        className,
        align: headingAlign,
        size: headingSize,
        tag: headingTag,
        data,
        tabIndex
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React17.createElement(EGDSPlainText, {
        className,
        align: textAlign,
        size: textSize,
        data,
        inline,
        theme
      });
    case "EGDSStylizedText":
      return /* @__PURE__ */React17.createElement(EGDSStylizedText, {
        className,
        align: textAlign,
        size: textSize,
        data,
        inline
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React17.createElement(EGDSGraphicText, {
        className,
        size: textSize,
        data
      });
    case "EGDSIconText":
      return /* @__PURE__ */React17.createElement(EGDSIconText, {
        className,
        size: textSize,
        data
      });
    case "EGDSParagraph":
      return /* @__PURE__ */React17.createElement(ActivitiesEGDSParagraph, {
        className,
        data
      });
    case "EGDSStandardLink":
      return /* @__PURE__ */React17.createElement(EGDSStandardLink, {
        className,
        data
      });
    case "EGDSInlineLink":
      return /* @__PURE__ */React17.createElement(EGDSInlineLink, {
        className,
        data
      });
    case "EGDSSpannableText":
      return /* @__PURE__ */React17.createElement(EGDSSpannableText, {
        className,
        size: textSize,
        headingSize,
        data,
        align,
        theme
      });
    default:
      return null;
  }
};
ActivitiesEGDSText.fragment = fragment11;
ActivitiesEGDSText.displayName = "ActivitiesEGDSText";

// ../internal/src/utils/eg-activity-clickstream-helper.ts
var buildClickstreamData = clickstreamAnalytics => {
  const {
    clickstreamEvent,
    payload: serverPayload
  } = clickstreamAnalytics;
  const {
    eventName,
    eventType,
    eventVersion,
    eventCategory,
    actionLocation,
    pageName,
    pageNameDetailed,
    pageProductLine
  } = clickstreamEvent;
  const eventData = {
    event_name: eventName,
    event_version: eventVersion,
    event_type: eventType,
    event_category: eventCategory,
    action_location: actionLocation
  };
  const experience = {
    page_name: pageName,
    page_name_detailed: pageNameDetailed,
    page_product_line: pageProductLine
  };
  return __spreadValues({
    clientPayload: {
      event: eventData,
      experience
    }
  }, serverPayload && {
    serverPayload
  });
};

// src/components/activity-faqs/activity-faqs.tsx
import { gql as gql18, useQuery } from "@shared-ui/apollo-client-wrapper";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";

// src/components/activity-faqs/__private/__fragments/activity-faqs-list.tsx
import React19 from "react";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";

// ../internal/src/components/egds-expando/egds-expando-list-item.tsx
import React18 from "react";
import { EGDSExpandoListItem } from "@egds/react-core/expando";
import { EGDSHeading as EGDSHeading2 } from "@egds/react-core/text";
import { gql as gql16 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker3, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
var fragment12 = gql16`
  fragment EGDSExpandoListItemFragment on EGDSExpandoListItem {
    collapseAnalytics {
      linkName
      referrerId
    }
    collapsedLabel
    expandAnalytics {
      linkName
      referrerId
    }
    expandedLabel
    expanded
  }
`;
var ActivitiesEGDSExpandoListItem = ({
  children,
  className,
  data,
  titleSize,
  titleTag,
  isIndented,
  selectedEventAnalytics
}) => {
  const {
    expandAnalytics,
    expandedLabel,
    collapseAnalytics,
    collapsedLabel,
    expanded
  } = data;
  const clickTracker = useClickTracker3();
  const trackEgClickStream = useEgClickstream();
  const [isVisible, setIsVisible] = React18.useState(expanded);
  const [label, setLabel] = React18.useState(expanded ? expandedLabel : collapsedLabel);
  let analytics;
  if (collapseAnalytics && expandAnalytics) {
    analytics = {
      id: isVisible ? collapseAnalytics.referrerId : expandAnalytics.referrerId,
      description: isVisible ? collapseAnalytics.linkName : expandAnalytics.linkName,
      callback: (referrerId, linkName) => {
        clickTracker(referrerId, linkName);
      }
    };
  }
  const onToggle = React18.useCallback(() => {
    if (isVisible) {
      setLabel(collapsedLabel);
    } else {
      setLabel(expandedLabel);
    }
    if (selectedEventAnalytics) {
      trackEgClickStream(buildClickstreamData(selectedEventAnalytics));
    }
    setIsVisible(!isVisible);
  }, [isVisible, collapsedLabel, expandedLabel]);
  return /* @__PURE__ */React18.createElement(EGDSExpandoListItem, {
    analytics,
    className,
    isVisible,
    expandoTitle: /* @__PURE__ */React18.createElement(EGDSHeading2, {
      tag: titleTag,
      size: titleSize
    }, label),
    expandoDescription: children,
    onToggle,
    isIndented
  });
};
ActivitiesEGDSExpandoListItem.fragment = fragment12;
ActivitiesEGDSExpandoListItem.displayName = "ActivitiesEGDSExpandoListItem";

// src/components/activity-faqs/__private/__fragments/activity-faqs-list.tsx
import { gql as gql17 } from "@shared-ui/apollo-client-wrapper";
var fragment13 = gql17`
  fragment ActivityFaqsListFragment on ActivityFAQ {
    question {
      ...EGDSExpandoListItemFragment
    }
    answer {
      ...EGDSTextFragment
    }
    selectedEventAnalytics {
      ...ActivityClickstreamAnalyticsFragment
    }
  }
  ${ActivitiesEGDSText.fragment}
  ${ActivitiesEGDSExpandoListItem.fragment}
  ${EGClickstreamActivityAnalyticsFragment}
`;
var ActivityFaqsList = ({
  className,
  data,
  expandoListItemIsIndented,
  expandoListItemTitleSize,
  expandoListItemTitleTag
}) => {
  if (!data || !data.question || !data.answer) {
    return null;
  }
  const {
    question,
    answer,
    selectedEventAnalytics
  } = data;
  return /* @__PURE__ */React19.createElement(EGDSSpacing3, {
    padding: {
      blockstart: "three",
      blockend: "two"
    }
  }, /* @__PURE__ */React19.createElement(ActivitiesEGDSExpandoListItem, {
    data: question,
    className,
    titleSize: expandoListItemTitleSize,
    titleTag: expandoListItemTitleTag,
    isIndented: expandoListItemIsIndented,
    selectedEventAnalytics
  }, /* @__PURE__ */React19.createElement(EGDSSpacing3, {
    padding: {
      inlinestart: "eight",
      blockstart: "two",
      blockend: "two"
    }
  }, /* @__PURE__ */React19.createElement(ActivitiesEGDSText, {
    data: answer
  }))));
};
ActivityFaqsList.fragment = fragment13;
ActivityFaqsList.displayName = "ActivityFaqsListFragment";

// src/components/activity-faqs/activity-faqs.tsx
var __Query = gql18`
  query ActivityFaqsQuery($context: ContextInput!, $activityId: String!) {
    activityInfo(context: $context, activityId: $activityId) {
      frequentlyAskedQuestions {
        heading {
          ...EGDSHeadingFragment
        }
        faqs {
          ...ActivityFaqsListFragment
        }
        presentedEventAnalytics {
          ...ActivityClickstreamAnalyticsFragment
        }
        failedEventAnalytics {
          ...ActivityClickstreamAnalyticsFragment
        }
      }
    }
  }
  ${ActivitiesEGDSHeading.fragment}
  ${ActivityFaqsList.fragment}
  ${EGClickstreamActivityAnalyticsFragment}
`;
var ActivityFaqs = ({
  inputs,
  skipSsr
}) => {
  var _a2;
  const {
    context
  } = useBexApi();
  const trackEgClickStream = useEgClickstream2();
  const variables = __spreadProps(__spreadValues({}, inputs), {
    context
  });
  const {
    activityId
  } = variables;
  const cardPadding = {
    small: {
      block: "six"
    },
    large: "six"
  };
  const faqGrid = {
    large: ["1fr", "2fr"]
  };
  const {
    data,
    error,
    loading
  } = useQuery(__Query, {
    variables,
    ssr: !skipSsr
  });
  React20.useEffect(() => {
    var _a3;
    if (!loading) {
      const faqs2 = (_a3 = data == null ? void 0 : data.activityInfo) == null ? void 0 : _a3.frequentlyAskedQuestions;
      if (faqs2 == null ? void 0 : faqs2.presentedEventAnalytics) {
        trackEgClickStream(buildClickstreamData(faqs2.presentedEventAnalytics));
      }
      if (faqs2 == null ? void 0 : faqs2.failedEventAnalytics) {
        trackEgClickStream(buildClickstreamData(faqs2.failedEventAnalytics));
      }
    }
  }, [loading, data]);
  if (loading || error || !((_a2 = data == null ? void 0 : data.activityInfo) == null ? void 0 : _a2.frequentlyAskedQuestions)) {
    return null;
  }
  const {
    heading,
    faqs
  } = data.activityInfo.frequentlyAskedQuestions;
  return /* @__PURE__ */React20.createElement(EGDSCard, null, /* @__PURE__ */React20.createElement(EGDSSpacing4, {
    padding: cardPadding
  }, /* @__PURE__ */React20.createElement(EGDSCardContentSection, null, /* @__PURE__ */React20.createElement(EGDSLayoutGrid, {
    columns: faqGrid,
    space: "two"
  }, /* @__PURE__ */React20.createElement(EGDSLayoutGridItem, null, heading && /* @__PURE__ */React20.createElement(ActivitiesEGDSHeading, {
    size: 4,
    data: heading,
    tabIndex: -1
  })), /* @__PURE__ */React20.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React20.createElement("div", {
    key: "questionsSection"
  }, faqs == null ? void 0 : faqs.map((item, index) => /* @__PURE__ */React20.createElement(ActivityFaqsList, {
    key: `activity-card-text-content-item-${activityId}-${index}`,
    data: item
  }))))))));
};
ActivityFaqs.displayName = "sharedui-ActivityFaqs";
export { ActivityFaqs };